import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_CLIENTS_ROUTE_LOADING = 'GET_CLIENTS_ROUTE_LOADING';
export const GET_CLIENTS_ROUTE_SUCCESS = 'GET_CLIENTS_ROUTE_SUCCESS';
export const GET_CLIENTS_ROUTE_REJECT = 'GET_CLIENTS_ROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const getClientsRouteLoading = () => ({ type: GET_CLIENTS_ROUTE_LOADING });
export const getClientsRouteSuccess = (payload) => ({ type: GET_CLIENTS_ROUTE_SUCCESS, payload });
export const getClientsRouteReject = (payload) => ({ type: GET_CLIENTS_ROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getClientsRouteRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/ClientesBillingTracking/web/GetClientesBillingTrackingRoutes`, options);
};

